import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { homeData } from "../../../mocks/homeData";
import { fetchSiteSettings, resolveAssetPath } from "../../../api";

/** 默认 Logo */
const DEFAULT_LOGO = "https://storage.readdy-site.link/project_files/870dd70f-e20b-4d95-a3c1-abdd0663e4f5/40837718-58c9-438e-a598-fe499966453f_logo.png?v=01d6c2cfcf3b187e46eae996fab2dd4f";

interface Props {
  data?: { title?: string; subtitle?: string; button?: string; bgImage?: string } | null;
}

export default function CTASection({ data: apiData }: Props) {
  const navigate = useNavigate();
  const [logoSrc, setLogoSrc] = useState(DEFAULT_LOGO);
  const cta = apiData?.title ? apiData : homeData.cta;

  useEffect(() => {
    fetchSiteSettings()
      .then((s) => {
        const resolved = resolveAssetPath(s.site_logo);
        if (resolved) setLogoSrc(resolved);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="relative w-full h-[480px] md:h-[560px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={cta.bgImage}
          alt="Communication tower background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white uppercase tracking-wider mb-4">
          {cta.title}
        </h2>
        <p className="text-white/80 text-base md:text-lg max-w-md mb-8">
          {cta.subtitle}
        </p>
        <a
          href="/contact"
          onClick={(e) => {
            e.preventDefault();
            navigate("/contact");
          }}
          className="inline-flex items-center gap-3 pl-1 pr-6 py-1 bg-dark text-white rounded-full hover:bg-gray-900 transition-colors"
        >
          <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden">
            <img
              src={logoSrc}
              alt="Huatera"
              className="h-6 w-auto min-w-[24px] object-contain"
            />
          </div>
          <span className="text-sm font-semibold uppercase tracking-wide">
            {cta.button}
          </span>
          <i className="ri-arrow-right-up-line text-white"></i>
        </a>
      </div>
    </section>
  );
}